import '../../styles/pages/404.scss';